import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { MatTable } from '@angular/material/table';
import { AdminValidationModalComponent } from '../admin-validation-modal/admin-validation-modal.component';
import { MatSort, Sort } from '@angular/material/sort';

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { ExcelService } from '../excel.service';
import { IMyDpOptions, IMyDate } from 'mydatepicker';
import { environment } from '../../../environments/environment';
import * as moment from 'moment-timezone';
import { utilityBlock } from 'src/app/shared/models/utility-block';

@Component({
  selector: 'app-admin-utility-report',
  templateUrl: './admin-utility-report.component.html',
  styleUrls: ['./admin-utility-report.component.css'],
})
export class AdminUtilityReportComponent implements OnInit {
  @ViewChild('empTbSort') empTbSort = new MatSort();
  @ViewChild('utilityPaginator', { read: MatPaginator })
  utilityPaginator: MatPaginator;
  options: string[] = ['Residential', 'Commercial'];
  Brands: string[] = ['Select'];
  TDSPs: string[] = ['Select'];
  public myDatePickerOptions1: IMyDpOptions;
  public myDatePickerOptions2: IMyDpOptions;
  utilitydisplayedColumns: string[] = [
    'currentStatus',
    'status',
    'customerId',
    'energy_provider',
    'utility_name',
    'ProfileCreatedDate',
    'createdDate',
    'switchDate',
    'legalFirstName',
    'legalLastName',
    'emailId',
    'homephoneNo',
    'mobilePhone',
    'workPhone',
    'authorizedRep',
    'esiid',
    'userAddress1',
    'userAddress2',
    'userCity',
    'userState',
    'userZIPCode',
    'billingAddress1',
    'billingAddress2',
    'billingCity',
    'billingState',
    'billingZIPCode',
    'serviceType',
    'RequestedDate',
    'endDate',
    'energyRate',
    'avgUsage',
    'term',
    'planName',
    'ConfirmationNumber',
    'renewableContent',
    'enrollmentSource',
    'UsedPromocode',
    'AffiliateName',
    'AffiliatePromoCode',
  ];
  utilityResult: utilityBlock[];

  utilityData: MatTableDataSource<utilityBlock>;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  selectedType: any = 'residential';
  url = environment.api_url;
  fromdate;
  todate;
  tUserCount: any;
  QuType: any;
  residentialCommercial: any;
  dialogValue: string;
  enrolledUserCt: any;
  DateValuesPicker = new Date();
  compareDate = false;
  selectedDates = false;
  residentialHeaderArray;
  commercialHeaderArray;
  commercialArray;
  display: string;
  AffiliateName;
  PromoCode;
  TDSP;
  Brand;
  AffiliateContactPerson;
  AffiliatePhone;
  constructor(
    private http: HttpClient,
    private router: Router,
    private excelService: ExcelService,
    private residentialService: ResidentialService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {
    // Date picker
    this.myDatePickerOptions1 = {
      // other options...
      todayBtnTxt: 'Today',
      dateFormat: 'mm/dd/yyyy',
      inline: false,
      showClearDateBtn: false,
      editableDateField: false,
      openSelectorOnInputClick: true,
      disableSince: {
        year: this.DateValuesPicker.getFullYear(),
        month: this.DateValuesPicker.getMonth() + 1,
        day: this.DateValuesPicker.getDate() + 1,
      },
    };
    this.Brand = 'Select';
    this.TDSP = 'Select';
    this.http
      .get(this.url + '/admin/dropdowns')
      .subscribe((res: any) => {

        this.Brands = [...this.Brands, ...res.EnergyProviders];
        this.TDSPs = [...this.TDSPs, ...res.UtilityNames];
        const indexToRemove = this.TDSPs.indexOf('CenterPoint Energy');
        if (indexToRemove !== -1) {
          this.TDSPs.splice(indexToRemove, 1);
        }

      })

  }

  ngOnInit(): void {}

  getFormattedDate(itemValue) {
    if (itemValue !== undefined) {
      const day =
        itemValue.date.day.toString().length === 1
          ? `0${itemValue.date.day}`
          : itemValue.date.day;
      const month =
        itemValue.date.month.toString().length === 1
          ? `0${itemValue.date.month}`
          : itemValue.date.month;

      return `${month}/${day}/${itemValue.date.year}`;
    }
  }
  setAverage(item) {
    return Math.round(item);
  }
  setCurrentStatus(item) {
    item = item == undefined ? '' : item == true ? "true" : ""
    if (item !== undefined) {
      // if (!item) {
      return item.includes('Completed')
        ? 'Active'
        : item.includes('Deposit Needed')
        ? 'Submitted'
        : 'Pending';
      // return item.includes('Completed') ? 'Active' : 'Pending';
    }
  }
  setRequestedDate(item) {
    const date = new Date();
    const priorityMovinDate = date.setDate(date.getDate() + 1);
    const standaredSwitchDate = date.setDate(date.getDate() + 5);
    const sDate = moment(new Date(standaredSwitchDate)).format('MM/DD/YYYY');
    const pMDate = moment(new Date(priorityMovinDate)).format('MM/DD/YYYY');
    // return !item.includes('/') ? item : datelist;
    return item.includes('/')
      ? item
      : item.includes('Standard Switch')
      ? sDate
      : pMDate;
    return;
  }
  setEndDate(item, row?) {
    // if ((item = undefined)) {
    const getdate = new Date(item);
    // console.log('gd', getdate, row['selectedProduct'].terms);
    var addedMonths = getdate.setMonth(
      getdate.getMonth() + +row['selectedProduct'].terms
    );
    const datelist = moment(new Date(addedMonths)).format('MM/DD/YYYY');
    //  const date = new Date();
    //   const toDayStandaredSwitchDate =  new Date();
    // console.log('date', date);
    const priorityMovinDate: any = new Date().setDate(new Date().getDate() + 1);
    const p = new Date(priorityMovinDate).setMonth(
      new Date(priorityMovinDate).getMonth() + +row['selectedProduct'].terms
    );
    const standaredSwitchDate: any = new Date().setDate(
      new Date().getDate() + 5
    );
    const s = new Date(standaredSwitchDate).setMonth(
      new Date(standaredSwitchDate).getMonth() + +row['selectedProduct'].terms
    );
    const sDate = moment(new Date(s)).format('MM/DD/YYYY');
    const pMDate = moment(new Date(p)).format('MM/DD/YYYY');
    // return !item.includes('/') ? item : datelist;
    return item.includes('/')
      ? datelist
      : item.includes('Standard Switch')
      ? sDate
      : pMDate;
    // }
  }
  setContent(item) {
    return item + '%';
  }
  resiClick(e) {
    const residentialRadio = <HTMLInputElement>(
      document.getElementById('residentialId')
    );
    if (residentialRadio.checked) {
      this.selectedDates = true;
      this.fromdate = '';
      this.todate = '';
    } else {
      this.selectedDates = false;
    }
  }

  openModal() {
    this.display = 'block';
  }

  onCloseHandled() {
    this.display = 'none';
  }

  formatDateTimeWithAMPM(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true, // Use 12-hour clock (AM/PM)
    };
  
    return date.toLocaleString('en-US', options);
  }
  callResidentialAPI() {

    this.selectedType = 'residential';
    let filterDate;
    if (this.selectedDates) {
      filterDate = new HttpParams()
        .append('fromDate', '')
        .append('toDate', '')
        .append('all', `all`)
        .append('AffiliateName', this.AffiliateName)
        .append('PromoCode', this.PromoCode)
        .append('AffiliateContactPerson', this.AffiliateContactPerson)
        .append('AffiliatePhone', this.AffiliatePhone)
        .append('Brand', this.Brand == 'Select' ? '' :this.Brand)
        .append('TDSP', this.TDSP == 'Select' ? '' : this.TDSP);
    } else {
      filterDate = new HttpParams()
        .append('fromDate', `${this.getFormattedDate(this.fromdate)} 00:00:00`)
        .append('toDate', `${this.getFormattedDate(this.todate)} 23:59:59`)
        .append('all', '')
        .append('AffiliateName', this.AffiliateName)
        .append('PromoCode', this.PromoCode)
        .append('AffiliateContactPerson', this.AffiliateContactPerson)
        .append('AffiliatePhone', this.AffiliatePhone)
        .append('Brand', this.Brand == 'Select' ? '' :this.Brand)
        .append('TDSP', this.TDSP == 'Select' ? '' : this.TDSP);
    }
    this.openModal();
    this.http
      .get(this.url + '/admin/residential', { params: filterDate })
      .subscribe((res: any) => {
        if (res.data.residentailListArr.length > 0) {
         
          var newo = res.data.residentailListArr;
          res.data.residentailListArr.forEach(function (value) {
            value['CurrentStatus'] = setCurrentStatus(value.status)
            value['hearusOption'] =  value.promoDetails &&  value.promoDetails.hearusOption ?  value.promoDetails.hearusOption : '';
            //value['promoeCode'] = value.promoDetails &&  value.promoDetails.promoeCode? value.promoDetails.promoeCode : '';
            value['promoeCode'] = value.ReceivedPromocode ? value.ReceivedPromocode : "";
            value['Renewable'] = value.selectedProduct && value.selectedProduct.Renewable ? setContent(value.selectedProduct.Renewable) : '';
            value['terms'] = value.selectedProduct && value.selectedProduct.terms ? value.selectedProduct.terms : ''
            value['ave_monthly_usage'] = value.selectedProduct && value.selectedProduct.new_tier.ave_monthly_usage ? value.selectedProduct.new_tier.ave_monthly_usage : ''
            value['energy_charge'] = value.selectedProduct && value.selectedProduct.new_tier.ave_price_per_KWH ? (value.selectedProduct.new_tier.ave_price_per_KWH * 100).toFixed(1) + '¢' : ''
            var requestdate = value.serviceTypeDetails && value.serviceTypeDetails.switchDate ?  setRequestedDate(value.serviceTypeDetails.switchDate, value.createdDate) : ''
            value['enddate'] = setnewEndDate(requestdate, value)
            value['RequestedDate'] = requestdate;
            value['switchDate'] = value.serviceTypeDetails &&  value.serviceTypeDetails.switchDate ? value.serviceTypeDetails.switchDate : ''
            value['serviceType'] = value.serviceTypeDetails &&  value.serviceTypeDetails.serviceType ?  value.serviceTypeDetails.serviceType : ''
            value['billingzipcode'] = value.billingAddress && value.billingAddress.billingAddress ? value.billingAddress.billingAddress.billingAddress.zipcode  : ''
            value['billingstate'] = value.billingAddress && value.billingAddress.billingAddress ? value.billingAddress.billingAddress.billingAddress.state : ''
            value['billingcity'] = value.billingAddress && value.billingAddress.billingAddress ? value.billingAddress.billingAddress.billingAddress.city : ''
            value['billingapartment'] = value.billingAddress && value.billingAddress.billingAddress ? value.billingAddress.billingAddress.apartment : ''
            value['billingstreet_address'] =  value.billingAddress && value.billingAddress.billingAddress ? value.billingAddress.billingAddress.billingAddress.street_address : ''
            value['serviceZipcode'] = value.billingAddress && value.billingAddress.userAddress ?  value.billingAddress.userAddress.zipcode : ''
            value['servicestate'] = value.billingAddress && value.billingAddress.userAddress ?  value.billingAddress.userAddress.state  : ''
            value['servicecity'] = value.billingAddress && value.billingAddress.userAddress ?  value.billingAddress.userAddress.city : ''
            value['serviceapartment'] = value.billingAddress && value.billingAddress.apartment ?  value.billingAddress.apartment : ''
            value['servicestreet_address'] = value.billingAddress && value.billingAddress.userAddress ?  value.billingAddress.userAddress.street_address : ''
            value['authorizedRep'] = value.contactInfo && value.contactInfo.authorizedRep ? value.contactInfo.authorizedRep : ''
            value['phoneNo'] = value.contactInfo && value.contactInfo.phoneNo ? value.contactInfo.phoneNo : ''
            value['emailId'] = value.contactInfo && value.contactInfo.emailId ? value.contactInfo.emailId :''
            value['legalLastName'] = value.contactInfo && value.contactInfo.legalLastName ? value.contactInfo.legalLastName : ''
            value['legalFirstName'] = value.contactInfo && value.contactInfo.legalFirstName ? value.contactInfo.legalFirstName : ''
            value['utility_name'] =  value.selectedProduct && value.selectedProduct.utility_name ? value.selectedProduct.utility_name : ''
            value['energy_provider'] = value.selectedProduct && value.selectedProduct.energy_provider ? value.selectedProduct.energy_provider : ''
            value['AffiliateName'] =  value.Affiliate ? value.Affiliate : ''
            value['AffiliatePromoCode'] =   value.AffiliatePromo ? value.AffiliatePromo : ''
            value['createdDate'] = new Date(value.createdDate)
            value['customerId'] =  value.selectedProduct &&  value.selectedProduct.energy_provider && (value.selectedProduct.energy_provider == "Frontier Utilities" || value.selectedProduct.energy_provider == "Gexa Energy" ) ? value.customerId : ""
            value['ProfileCreatedDate'] = value.ProfileCreatedDate == null ? null : new Date(value.ProfileCreatedDate)
            delete value.selectedProduct;
            delete value.contactInfo;
            delete value.billingAddress;
            delete value.serviceTypeDetails;
            delete value.promoDetails;
            delete value.privateDetails;



          }); 
          this.utilityResult = res.data.residentailListArr;
          this.utilityData = new MatTableDataSource<utilityBlock>(
            this.utilityResult
          );
          this.utilityData.paginator = this.utilityPaginator;
          this.utilityData.sort = this.empTbSort;
        } else {
          const dialogRef = this.dialog.open(AdminValidationModalComponent, {
            width: '500px',
          });
        }
        this.display = 'none';
      });
  }
  sDatePicker() {
    // Date picker
    this.myDatePickerOptions2 = {
      todayBtnTxt: 'Today',
      dateFormat: 'mm/dd/yyyy',
      inline: false,
      showClearDateBtn: false,
      editableDateField: false,
      openSelectorOnInputClick: true,
      disableSince: {
        year: this.DateValuesPicker.getFullYear(),
        month: this.DateValuesPicker.getMonth() + 1,
        day: this.DateValuesPicker.getDate() + 1,
      },
    };

    const compareFirst = new Date(
      this.fromdate.date.year,
      this.fromdate.date.month - 1,
      this.fromdate.date.day
    );
    const compareSecond = new Date(
      this.todate.date.year,
      this.todate.date.month - 1,
      this.todate.date.day
    );
    if (compareFirst <= compareSecond) {
      this.compareDate = false;
    } else {
      this.compareDate = true;
    }
  }
  GetDataTable() {
    this.callResidentialAPI();
  }
  setExcelColumnsData() {
    let dataArr = [];
    this.utilityData.filteredData.map((row: any) => {
      const columns = {
        'Current Status': this.setCurrentStatus(row.status),
        Status: row.status,
        'Customer ID': row.customerId,
        Brand: row.energy_provider,
        TSDP: row.utility_name,
        'Profile Creation Date': row.ProfileCreatedDate,
        'Service Start Date': row.switchDate,
        'Signup Date': row.createdDate,
        'First Name': row.legalFirstName,
        'Last Name': row.legalLastName,
        'Email Address': row.emailId,
        'Home Phone': row.phoneNo,
        'Mobile Phone': row.phoneNo,
        'Work Phone': row.phoneNo,
        'Authorized Representative': row.authorizedRep,
        ESIID: row.esiid,
        'Service Address 1': row.servicestreet_address,
        'Service Address 2': row.serviceapartment,
        'Service City': row.servicecity,
        'Service State': row.servicestate,
        'Service Zip Code': row.serviceZipcode,
        'Billing Address 1':
          row.billingstreet_address,
        'Billing Address 2': row.billingapartment,
        'Billing City': row.billingcity,
        'Billing State': row.billingstate,
        'Billing ZIPCode': row.billingzipcode,
        'Service Type': row.serviceType,
        'Requested Start Date': row.RequestedDate,
        'End Date': row.enddate,
        'Energy Rate': row.energy_charge,
        ConfirmationNumber: row.ConfirmationNumber,
        'Avg Usage': row.ave_monthly_usage,
        Term: row.terms,
        'Plan Name': row.ratePlanName,
        'Renewable Content': row.Renewable,
        'Enrollment Source': row.hearusOption,
        'Promo Code': row.promoeCode,
        
      };
      dataArr.push(columns);
    });
    return dataArr;
  }


  
  exportAsXLSX() {
    if (this.utilityData) {
      if (this.selectedType === 'residential') {
        this.residentialHeaderArray = this.utilitydisplayedColumns;
        this.excelService.generateExcel(
          this.setExcelColumnsData(),
          this.residentialHeaderArray,
          null,
          null,
          this.selectedType,
          this.enrolledUserCt,
          this.tUserCount
        );
      }
    } else {
      const dialogRef = this.dialog.open(AdminValidationModalComponent, {
        width: '500px',
      });

      dialogRef.afterClosed().subscribe((result) => {});
    }
  }

  AFFilationClick()
  {
     this.router.navigate([
            'hg-admin-affiliate-addedit',
           
          ]);
  }


}

function pad(number) {
  return (number < 10 ? '0' : '') + number;
}
function setDateValueFor4CE(month, day, year) {
 // return this.selectedProduct.energy_provider === '4Change Energy'
 //   ? `${year}-${this.pad(month)}-${this.pad(day)}`
   // : `${this.pad(month)}/${this.pad(day)}/${year}`;
   return `${pad(month)}/${pad(day)}/${year}`;
  }

function suffixZeroToSelectedSwitchDate(d) {
  let newDate;
//  if (new Date(d) < new Date()) d = new Date();
  newDate = setDateValueFor4CE(
    `${d.getMonth() + 1}`,
    `${d.getDate()}`,
    `${d.getFullYear()}`
  );
  return new Date(newDate);
}

function setCurrentStatus(item) {
  item = item == undefined ? '' : item == true ? "true" : ""
  if (item !== undefined) {
    // if (!item) {
    return item.indexOf('Completed') > -1
      ? 'Active'
      : item.indexOf('Deposit Needed') > -1
      ? 'Submitted'
      : 'Pending';
    // return item.includes('Completed') ? 'Active' : 'Pending';
  }
  return item;
}


function setContent(item) {
  return item + '%';
}

function assignNewDateForSelectedSwitchDate(selectedSwitchDate) {
    
  let newdate
  
    // const currentDate = new Date(
    //   new Date().getTime() + 3 * 24 * 60 * 60 * 1000
    // );
    let currentDate = new Date(selectedSwitchDate),
      endDate,
      noOfDaysToAdd = 3,
      count = 0;
    while (count < noOfDaysToAdd) {
      endDate = new Date(currentDate.setDate(currentDate.getDate() + 1));
      if (endDate.getDay() != 0 && endDate.getDay() != 6) {
        count++;
      }
    }
    newdate = suffixZeroToSelectedSwitchDate(endDate);
    // newdate = this.setDateValueFor4CE(
    //   endDate.getMonth() + 1,
    //   endDate.getDate(),
    //   endDate.getFullYear()
    // );
  
  return newdate;
}


function setRequestedDate(item,createdDate) {
  item = item == undefined ? '' : item
  const date = new Date(createdDate);
  const priorityMovinDate = date.setDate(date.getDate() + 1);
  const standaredSwitchDate = date.setDate(date.getDate() + 5);
  const sDate = moment(new Date(standaredSwitchDate));
  const pMDate = moment(new Date(priorityMovinDate));
  // return !item.includes('/') ? item : datelist;
  return item.indexOf('/') > -1
    ? new Date(item)
    : assignNewDateForSelectedSwitchDate(createdDate);
  return;
}
function setnewEndDate(item, row?)
{
  item = item == undefined ? '' : item
  // if ((item = undefined)) {
  const getdate = new Date(item);

  var addedMonths = getdate.setMonth(
    getdate.getMonth() + +row['selectedProduct'].terms
  );
  const datelist = moment(new Date(addedMonths)).format('MM/DD/YYYY');

  return datelist
}

function setEndDate(item, row?) {
  item = item == undefined ? '' : item
  // if ((item = undefined)) {
  const getdate = new Date(item);
  // console.log('gd', getdate, row['selectedProduct'].terms);
  var addedMonths = getdate.setMonth(
    getdate.getMonth() + +row['selectedProduct'].terms
  );
  const datelist = moment(new Date(addedMonths)).format('MM/DD/YYYY');
  //  const date = new Date();
  //   const toDayStandaredSwitchDate =  new Date();
  // console.log('date', date);
  const priorityMovinDate: any = new Date().setDate(new Date().getDate() + 1);
  const p = new Date(priorityMovinDate).setMonth(
    new Date(priorityMovinDate).getMonth() + +row['selectedProduct'].terms
  );
  const standaredSwitchDate: any = new Date().setDate(
    new Date().getDate() + 5
  );
  const s = new Date(standaredSwitchDate).setMonth(
    new Date(standaredSwitchDate).getMonth() + +row['selectedProduct'].terms
  );
  const sDate = moment(new Date(s)).format('MM/DD/YYYY');
  const pMDate = moment(new Date(p)).format('MM/DD/YYYY');
  // return !item.includes('/') ? item : datelist;
  return item.indexOf('/') > -1
    ? datelist
    : item.indexOf('Standard Switch') > -1
    ? sDate
    : pMDate;
  // }
}